import React, { useEffect, useState } from 'react';
import properties from '../../config/environmentProperties';
import { InputText } from "primereact/inputtext";
import { Button } from 'primereact/button';
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { Editor } from 'primereact/editor';
import { useFormik } from "formik";
import { trainingApi } from "../../services";
import moment from "moment";
import { toast } from "react-toastify";
import { Dialog } from 'primereact/dialog';
import { Carousel } from 'primereact/carousel';

const TrainingValidationForm = ({ validationData, closeDialoge, reload, type, selectedFeedbackType }) => {
    const docPath = properties.currentEnvironment.docPath + 'training-documents/';
    const [certificateVisible, setCertificateVisible] = useState(false);

    /* Uploaded Document View on Popup */
    const certificatePopup = () => {
        return (
            <Dialog header={'Documents'} visible={certificateVisible} modal style={{ width: '1200px', height: '900px' }} onHide={() => setCertificateVisible(false)}>
                {renderCertificateContent(validationData)}
            </Dialog>
        )
    }

    const renderCertificateContent = (rowData) => {
        return (
            <Carousel
                value={rowData?.trainingDocuments}
                itemTemplate={yourCarouselItemTemplate}
                numVisible={1}
                numScroll={1}
                circular
            />
        );
    };

    const yourCarouselItemTemplate = (doc) => {
        return (
            <>
                <p>{doc.fileName}</p>
                <iframe src={docPath + doc.fileName} title={`Document ${doc.fileName}`} style={{ width: '100%', height: '900px' }} />
            </>
        )
    };
    /* Uploaded Document View on Popup */
    const renderHeader = () => {
        return (
            <span className="ql-formats">
                <button className="ql-bold" aria-label="Bold"></button>
                <button className="ql-italic" aria-label="Italic"></button>
                <button className="ql-underline" aria-label="Underline"></button>
            </span>
        );
    }

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return (
            isFormFieldValid(name) && (
                <small className="p-error">{formik.errors[name]}</small>
            )
        );
    };

    const formik = useFormik({
        initialValues: {
            trainingType: selectedFeedbackType === 0 ? type === 'normal' ? validationData?.trainingType : validationData?.trainingRequisitionForm?.trainingType : '',
            targetSkill: selectedFeedbackType === 0 ? type === 'normal' ? validationData?.targetSkills.title : validationData?.trainingRequisitionForm?.targetSkills.title : '',
            nameOfNominatedParticipant: selectedFeedbackType === 0 ?  type === 'normal' ? validationData?.userDetails?.firstName + ' ' + validationData?.userDetails?.lastName : validationData?.trainingRequisitionForm?.nameOfNominatedParticipant : '',
            categoryOfTraining: selectedFeedbackType === 0 ? type === 'normal' ? validationData?.categoryOfTrainings?.title : validationData?.trainingRequisitionForm?.categoryOfTrainings?.title : '',
            trainingDoc: null,
            // skillRating: null,
            trainingStatus: selectedFeedbackType === 0 ?  type === 'normal' ? validationData?.trainingDetailStatus === 0 ? 'Not Started' : validationData?.trainingDetailStatus === 1 ? 'In Progress' : 'Completed' : validationData?.trainingDetailStatus === 0 ? 'Not Started' : validationData?.trainingRequisitionForm?.trainingDetailStatus === 1 ? 'In Progress' : 'Completed' : '',
            validationFeedback: '',
        },
        validate: (data) => {
            let errors = {};
            // if (!data.skillRating) errors.skillRating = 'Rating is required.';
            if (!data.validationFeedback) errors.validationFeedback = 'Feedback is required.';
            return errors;
        },
        onSubmit: (data) => {
            let params = {
                // "id": type === 'normal' ? validationData?.id : validationData?.trainingRequisitionForm?.trainingDetails[0]?.id,

                ids: selectedFeedbackType === 1 ? validationData.map(item => item.id) : type === 'normal' ? [validationData?.id] : [validationData?.trainingRequisitionForm?.trainingDetails[0]?.id],
                // "skillRating": data.skillRating,
                "feedback": data.validationFeedback,
                "isManagerValidate": true,
            }
            try {
                trainingApi.updateEmployeeTraining(params).then(
                    (resp) => {
                        toast.success(resp.data.message);
                        setTimeout(() => {
                            closeDialoge();
                            reload();
                        }, 1000);
                    },
                    (err) => {
                        toast.error(err.response.data.error);
                    }
                );
            } catch (error) {
                toast.error("Unable to update");
            }

        },
    });

    return (
        <>
            <form onSubmit={formik.handleSubmit} autoComplete='off'>
                {selectedFeedbackType === 0 &&
                    <div className="flex flex-wrap p-field font-bold block">
                        <div className="col-4">
                            <label htmlFor="text" className="font-bold block mb-2 training-heading mt-2">
                                Training Completion Certificate
                            </label>
                            <Button onClick={() => setCertificateVisible(true)} label="View Certificate" icon="pi pi-eye" type='button' className="w-full bg-bluegray-600 hover:bg-bluegray-400 border-bluegray-700" disabled={validationData?.trainingDocuments?.length > 0 ? false : true} />
                        </div>
                    </div>
                }
                <div className="flex flex-wrap p-field font-bold block">
                    {selectedFeedbackType === 0 &&
                        <>
                            <div className="col-4">
                                <label htmlFor="text" className="font-bold block mb-2 training-heading mt-2">
                                    Training Type
                                </label>
                                <InputText disabled placeholder="Training Type" className="w-full" name="trainingType" value={formik.values.trainingType} />
                            </div>
                            <div className="col-4">
                                <label htmlFor="text" className="font-bold block mb-2 training-heading mt-2">
                                    Target Skill
                                </label>
                                <InputText disabled placeholder="Target Skill" className="w-full" name="targetSkill" value={formik.values.targetSkill} />
                            </div>
                            <div className="col-4">
                                <label htmlFor="text" className="font-bold block mb-2 training-heading mt-2">
                                    Employee Name
                                </label>
                                <InputText disabled placeholder="Name" className="w-full" name="nameOfNominatedParticipant" value={formik.values.nameOfNominatedParticipant} />
                            </div>
                            <div className="col-4">
                                <label htmlFor="text" className="font-bold block mb-2 training-heading mt-2">
                                    Category Of Training
                                </label>
                                <InputText disabled placeholder="Training" name="categoryOfTraining" value={formik.values.categoryOfTraining} className="w-full" />
                            </div>

                            <div className="col-4">
                                <label htmlFor="trainingStatus" className="font-bold block mb-2 training-heading mt-2">Training Status</label>
                                <InputText disabled placeholder="Training" name="trainingStatus" value={formik.values.trainingStatus} className="w-full" />
                            </div>
                        </>
                    }
                    {/* <div className="col-4">
                        <label htmlFor="skillRating" className="font-bold block mb-2 training-heading mt-2">
                            Skill Rating Update
                        </label>
                        <Dropdown name="skillRating" value={formik.values.skillRating} options={ratingOptions} optionLabel={(option) => `${option.code} - ${option.title}`} optionValue="code" onChange={(e) => formik.handleChange(e)} placeholder="Select Rating" className="w-full" />
                        {getFormErrorMessage('skillRating')}
                    </div> */}

                    <div className="col-12">
                        <label htmlFor="feedback" className="font-bold block mb-2 training-heading">
                            Feedback
                        </label>
                        {/* <Editor headerTemplate={renderHeader} style={{ height: '200px' }} placeholder="Provide feedback" /> */}
                        <InputTextarea name="validationFeedback" value={formik.values.validationFeedback} onChange={formik.handleChange} placeholder="Feedback" rows={4} className="w-full" style={{ background: "#fff" }} />
                        {getFormErrorMessage('validationFeedback')}
                    </div>
                </div>
                <div className="flex flex-wrap p-field font-bold block mt-2">
                    <div className="col-12">
                        <p className="guidelines">
                            <strong>Skill Updating Guidelines:</strong> Ensure that the feedback
                            is constructive and aligns with the skill development goals. Ratings
                            should reflect the employee's performance in the training.
                        </p>
                    </div>
                </div>

                <hr />
                <div className='' style={{ textAlign: 'right' }}>
                    <Button label='Submit' icon='pi pi-save' severity='primary' className='mr-1' />
                    <Button label='Cancel' type='button' icon='pi pi-times' severity='secondary' onClick={reload} />
                </div>
            </form>
            {certificatePopup()}
        </>
    )
}

export default TrainingValidationForm;